export function onFileRequestOpen(file?: string) {
	if (!file) return;
	if (typeof window !== `undefined`) {
		window?.open(file, "_blank", "noreferrer noopener");
	}
}
